// src/components/Common/CompetitionLogoImage.js

import React from 'react';
import { Box, Typography } from '@mui/material';
import { EmojiEvents as TrophyIcon } from '@mui/icons-material';

const CompetitionLogoImage = ({ 
  src, 
  alt, 
  width = '100%', 
  height = 80, 
  competitionName = 'Logo',
  borderRadius = '8px',
  showPlaceholder = true,
  sx = {} 
}) => {
  
  // Placeholder específico para logos (más pequeño y diferente texto)
  const LogoPlaceholder = () => (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        background: 'linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)', // Diferente gradient
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Patrón de fondo más sutil para logo */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `
            radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15) 0%, transparent 40%),
            radial-gradient(circle at 70% 70%, rgba(255,255,255,0.15) 0%, transparent 40%)
          `,
        }}
      />
      
      {/* Icono más pequeño para logo */}
      <TrophyIcon sx={{ fontSize: 32, mb: 0.5, opacity: 0.9 }} />
      <Typography 
        variant="body2" 
        sx={{ 
          fontWeight: 'bold', 
          textAlign: 'center',
          px: 1,
          textShadow: '0 2px 4px rgba(0,0,0,0.3)',
          fontSize: '0.85rem',
          lineHeight: 1.1
        }}
      >
        {competitionName}
      </Typography>
      <Typography 
        variant="caption" 
        sx={{ 
          opacity: 0.8,
          textAlign: 'center',
          mt: 0.2,
          textShadow: '0 1px 2px rgba(0,0,0,0.3)',
          fontSize: '0.7rem'
        }}
      >
        Logo
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: width,
        height: height,
        borderRadius: borderRadius,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#f5f5f5',
        ...sx
      }}
    >
      {src ? (
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain', // Cambiar a 'contain' para logos para no cortarlos
            display: 'block',
          }}
          onError={(e) => {
            if (showPlaceholder) {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }
          }}
        />
      ) : null}
      
      {/* Mostrar placeholder si no hay src */}
      <Box
        sx={{
          position: src ? 'absolute' : 'static',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: src ? 'none' : 'flex',
        }}
      >
        {showPlaceholder && <LogoPlaceholder />}
      </Box>
    </Box>
  );
};

export default CompetitionLogoImage;